// extracted by mini-css-extract-plugin
export default {"editableWrapper":"editor_editableWrapper__x2LA2"};